import React from 'react';
import { Link } from 'react-router-dom';
import LegalPageLayout from '../../components/legal/LegalPageLayout';
import { SELLER } from './sellerInfo';

export const DistanceSalesPage = () => (
  <LegalPageLayout title="Mesafeli Satış Sözleşmesi" enTitle="Distance Sales Agreement" updatedAt="16 Ekim 2026">
    <p className="legal-intro">
      Bu sözleşme, aşağıda bilgileri yer alan Satıcı ile {SELLER.website} üzerinden abonelik satın alan
      Alıcı arasında, 6502 sayılı Tüketicinin Korunması Hakkında Kanun ve Mesafeli Sözleşmeler Yönetmeliği
      çerçevesinde elektronik ortamda kurulmuştur.
    </p>

    <h2>1. Taraflar</h2>
    <p>
      <strong>Satıcı:</strong> {SELLER.name} ("{SELLER.tradeName}" ticari adıyla), Vergi Kimlik No: {SELLER.taxNumber},{' '}
      {SELLER.taxOffice}. Adres: {SELLER.address}. Telefon: {SELLER.phone}.{' '}
      E-posta: <a href={`mailto:${SELLER.email}`}>{SELLER.email}</a>. KEP: {SELLER.kep}.
    </p>
    <p>
      <strong>Alıcı:</strong> Ödeme sırasında "Plan ve Ödeme" sayfasındaki fatura bilgilerinde adı/unvanı, vergi veya
      TC kimlik numarası ve adresi belirtilen gerçek ya da tüzel kişi.
    </p>

    <h2>2. Sözleşmenin Konusu</h2>
    <p>
      Konu, Satıcı'nın sunduğu e-posta imza yönetim yazılımının (Hizmet) "Pro" aboneliğinin, Alıcı'nın
      seçtiği kullanıcı (koltuk) sayısı ve ödeme dönemi (aylık veya yıllık) için kullanım hakkının
      satışıdır. Hizmetin kapsamı <Link to="/kullanim-sartlari">Kullanım Şartları</Link>'nda tanımlıdır.
    </p>

    <h2>3. Bedel ve Ödeme</h2>
    <ul>
      <li>Liste fiyatı kullanıcı başına aylık 2 ABD dolarıdır; yıllık ödemede %20 indirim uygulanır (kullanıcı başına yıllık 19,20 ABD doları). Fiyatlara KDV dahil değildir; %20 KDV ayrıca eklenir.</li>
      <li>Ödeme Türk lirası olarak alınır. KDV dahil ABD doları tutar, ödeme anındaki T.C. Merkez Bankası döviz satış kuruyla Türk lirasına çevrilir ve sipariş özetinde gösterilir. Kartınızdan çekilen tutar bu tutardır.</li>
      <li>Ödeme, PAYTR Ödeme ve Elektronik Para Kuruluşu A.Ş. altyapısıyla kredi veya banka kartıyla yapılır. Kart bilgileri Satıcı'nın sunucularına ulaşmaz.</li>
      <li>Dönem içinde kullanıcı eklenirse, eklenen kullanıcılar için yalnızca mevcut dönemin kalan günlerine düşen bedel alınır.</li>
    </ul>

    <h2>4. Otomatik Yenileme</h2>
    <p>
      Abonelik, dönem sonunda aynı kullanıcı sayısı ve dönemle, PAYTR'da saklanan kartınızdan otomatik olarak yenilenir.
      Yenileme bedeli, yenileme günündeki T.C. Merkez Bankası döviz satış kuruyla hesaplanır. Dönem bitiminden 3 gün önce
      e-posta ile bilgilendirilirsiniz. Otomatik yenilemeyi "Plan ve Ödeme" sayfasından istediğiniz zaman kapatabilirsiniz;
      bu durumda abonelik ödenmiş dönemin sonunda sona erer. Yenileme çekimi başarısız olursa 3 gün boyunca yeniden
      denenir, ardından otomatik yenileme kapatılır.
    </p>

    <h2>5. Hizmetin İfası</h2>
    <p>
      Hizmet, ödemenin onaylanmasıyla birlikte elektronik ortamda derhal kullanıma açılır. Hizmetin çalışması için
      Alıcı'nın Microsoft 365 hesabını bağlaması ve Outlook eklentisini dağıtması gerekir; bu adımlar Alıcı'nın
      sorumluluğundadır.
    </p>

    <h2>6. Cayma Hakkı</h2>
    <p>
      Mesafeli Sözleşmeler Yönetmeliği'nin 15. maddesinin (ğ) bendi uyarınca, elektronik ortamda anında ifa edilen
      hizmetlerde cayma hakkı kullanılamaz. Alıcı, ödeme sırasında bu sözleşmeyi onaylayarak hizmetin ifasına derhal
      başlanmasını kabul eder. Alıcı'nın tacir olduğu durumlarda tüketici mevzuatındaki cayma hakkı hükümleri
      uygulanmaz.
    </p>

    <h2>7. İptal ve İade</h2>
    <ul>
      <li>Aboneliği iptal etmek için otomatik yenilemeyi kapatmanız yeterlidir; erişim ödenmiş dönemin sonuna kadar devam eder.</li>
      <li>Başlamış bir dönemin bedeli, kullanılmayan günler için iade edilmez.</li>
      <li>Mükerrer veya hatalı çekimler, <a href={`mailto:${SELLER.email}`}>{SELLER.email}</a> adresine bildirildiğinde incelenir ve çekimin yapıldığı karta iade edilir.</li>
    </ul>

    <h2>8. Fatura</h2>
    <p>
      Her ödeme için Alıcı'nın fatura bilgileriyle e-Arşiv fatura düzenlenir ve fatura e-posta adresine gönderilir.
    </p>

    <h2>9. Uyuşmazlıklar</h2>
    <p>
      Tüketici niteliğindeki Alıcı, şikâyet ve itirazlarını Ticaret Bakanlığı'nca ilan edilen parasal sınırlar
      dahilinde yerleşim yerindeki Tüketici Hakem Heyeti'ne veya Tüketici Mahkemesi'ne iletebilir. Tacir Alıcılarla
      uyuşmazlıklarda İstanbul (Anadolu) Mahkemeleri ve İcra Daireleri yetkilidir.
    </p>

    <h2>10. Yürürlük</h2>
    <p>
      Alıcı, ödeme öncesinde bu sözleşmeyi ve <Link to="/on-bilgilendirme-formu">Ön Bilgilendirme Formu</Link>'nu
      elektronik ortamda okuyup onaylar; sözleşme ödemenin tamamlanmasıyla yürürlüğe girer. Onay zamanı ve sözleşme
      sürümü sipariş kaydında saklanır.
    </p>
  </LegalPageLayout>
);

export default DistanceSalesPage;
